import { Navigate, Route, Routes } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import GameBuilder from "./game-builder/GameBuilder";
import { ControlCenterPage } from "./control-center/ControlCenter";
import { useSupabase } from "../auth/useSupabase";
import Player from "../player/Player";
import { Box, CircularProgress } from "@mui/material";

const AdminRoutes = () => {
  const { loading } = useSupabase();

  if (loading) {
    return (
      <Box
        display="flex"
        width="100vw"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/game/:gameId/builder" element={<GameBuilder />} />
      <Route path="/game/:gameId/admin" element={<ControlCenterPage />} />
      <Route path="/game/:gameId" element={<Player />} />
      <Route path="*" element={<Navigate to="/admin" />} />
    </Routes>
  );
};

export default AdminRoutes;
